import SVGInject from "@iconfu/svg-inject";

SVGInject(document.querySelectorAll("img.injectable"));
